import { FC } from "react";
import Layout from "@/components/layout";
import styles from "./index.module.scss";
import { Button } from "@/components/button";
import { useTranslation } from "react-i18next";
import { StillThereModal } from "@/components/still-there-modal";
import { Routes } from "@/types/routes";
import useInternetConnectionStore from "@/stores/internet-connection";
import { playSound, SoundOption } from "@/helpers/playSound";

interface ErrorScreenProps {
  onTryAgain: () => void;
}

const ErrorScreen: FC<ErrorScreenProps> = ({ onTryAgain }) => {
  const { t } = useTranslation();
  const { showConnectionError, setShowConnectionError } = useInternetConnectionStore();

  const tryAgain = () => {
    playSound(SoundOption.Click1);
    setShowConnectionError(false);
    onTryAgain();
  };

  const showStillThereModal = window.location.pathname !== Routes.START;

  return (
    <Layout childrenClassName={styles.container}>
      <div className={styles.topBar} />
      <div className={styles.rest}>
        <div>
          <div className={styles.wave} />
          <h1 className={styles.title} data-cy="error-screen-title">
            {showConnectionError ? t("errorScreen.noInternetTitle") : t("errorScreen.title")}
          </h1>
          <p className={styles.subTitle}>{t("errorScreen.subTitle")}</p>
        </div>
        <Button
          text={t("ui.tryAgain")}
          onClick={tryAgain}
          size="x-small"
          className={styles.button}
        />
      </div>
      {showStillThereModal && <StillThereModal />}
    </Layout>
  );
};

export default ErrorScreen;
